import { ColorKeys, Mode } from 'canoe';

export const getIconColor = ({
  color,
  mode,
  isActive,
  isCheckbox,
  isHovered,
}: {
  color: 'default' | 'light' | 'orange' | 'grey';
  mode: Mode;
  isActive: boolean;
  isCheckbox?: boolean;
  isHovered: boolean;
}): ColorKeys => {
  // default value for active toggle
  let iconColor = 'White';

  if (!isActive) {
    if (mode === 'Dark') {
      iconColor = isHovered ? 'GlitterGrayD20' : 'GlitterGrayD10';
    } else if (isCheckbox) {
      iconColor = isHovered ? 'GlitterGrayD20' : 'GlitterGrayD10';
    } else if (color === 'light') {
      iconColor = isHovered ? 'GlitterGrayD10' : 'GlitterGray';
    } else if (color === 'default') {
      iconColor = isHovered ? 'OnyxGrayL10' : 'OnyxGrayL20';
    }
  }

  if (color === 'orange') {
    if (isActive) {
      iconColor = isHovered ? 'OnyxGrayD20' : 'OnyxGrayD10';
    }
    iconColor = isHovered ? 'GlitterGrayD10' : 'GlitterGray';
  }

  if (color === 'grey') {
    if (mode === 'Dark') {
      if (isActive && isHovered) {
        iconColor = 'OnyxGray';
      }
      if (!isActive) {
        iconColor = isHovered ? 'GlitterGray' : 'GlitterGrayD10';
      }
    } else {
      if (isActive && isHovered) {
        iconColor = 'OnyxGrayD10';
      }
      if (!isActive) {
        iconColor = isHovered ? 'OnyxGray' : 'OnyxGrayL30';
      }
    }
  }

  return iconColor as ColorKeys;
};
